import axios from 'axios'
import API_URL from '@/router/api'
import * as types from './mutation-types'

export const create = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.tag.create, form)
            .then(res => {
                for (let x in res.data.data) {
                    ctx.commit(types.ADD_TAG, res.data.data[x])
                }

                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const update = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {

        const url = API_URL.tag.update.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const findMany = (ctx, query = {}) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.tag.findMany

        axios.get(url, {
            params: query
        }).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findAll = (ctx, query) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.tag.findAll

        axios.get(url, {
            params: query
        }).then(res => {
            ctx.commit(types.SET_TAG, res.data.data.data)
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const list = (ctx, query) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.tag.findAll

        axios.get(url, {
            params: query
        }).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findCategory = () => {
    return new Promise((resolve, reject) => {
        const url = API_URL.tag.findAll

        axios.get(url, {
            params: {
                type: 'category'
            }
        })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
}

export const deleteTag = (ctx, {id}) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.tag.delete.replace(/__id__/, id)
        axios.delete(url)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
        }
    )
}

export const deleteMany = (ctx, {ids}) => {
    return new Promise((resolve, reject) => {
        axios.delete(API_URL.tag.deleteMany, {
            params: { ids: ids }
        }).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}


export const getApi = () => {
    return new Promise((resolve, reject) => {
        axios.get(API_URL.googleApi.get)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
        }
    )
}
